import { Box, Container } from '@mui/material';
import {
  HeroHeader,
  ScreenshotsGallery,
  CTASection,
  FeaturesGrid,
} from '@/components/Home';

export const HeroSection = () => {
  return (
    <Box sx={{ py: { xs: 8, md: 12 } }}>
      <Container maxWidth="lg">
        <HeroHeader />
        <ScreenshotsGallery />
        <CTASection />
        <FeaturesGrid />
      </Container>
    </Box>
  );
};
